import React from "react";
export default function FieldTitle({ title, isRequire = false }) {
  return (
    <div className="text-[15px] text-[#666666]">
      {isRequire && <span className="text-red-500">*</span>}
      {title}
    </div>
  );
}
